<app-complex-modal-template
    class="overflow-visible"
    [canConfirm]="createCableForm.valid"
    [title]="'synoptic.addCable' | transloco"
    (onClickEvent)="onClickEvent($event)">
    @if (isLoading()) {
        <app-loading />
    } @else {
        <form [formGroup]="createCableForm">
            <div class="flex flex-row items-start w-full mt-6 mb-6">
                <div class="flex flex-col w-80">
                    <app-select
                        [enableSort]="false"
                        [isMultiSelect]="true"
                        [label]="'synoptic.cables' | transloco"
                        [placeholder]="'synoptic.enterCableName'"
                        [(options)]="cables"
                        (optionSelected)="onSelectCablesChange($event)" />
                </div>
            </div>
        </form>
    }
</app-complex-modal-template>
